import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=7f3f5442&scoped=true&"
import script from "./Teacher.vue?vue&type=script&lang=js&"
export * from "./Teacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3f5442",
  null
  
)

export default component.exports